import { render, staticRenderFns } from "./access.vue?vue&type=template&id=043138cc&scoped=true"
import script from "./access.vue?vue&type=script&lang=js"
export * from "./access.vue?vue&type=script&lang=js"
import style0 from "./access.vue?vue&type=style&index=0&id=043138cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043138cc",
  null
  
)

export default component.exports